import { OrganizationEventSummaryRecord } from "models/view-models/contracts/organization-event-summary-record";
import { QUERY_KEYS } from "../query-keys";
import { ServiceResponse } from "andculturecode-javascript-core";
import { useQuery } from "@tanstack/react-query";
import { OrganizationEventRecord } from "models/view-models/contracts/organization-event-record";

export const useGetOrganizationEventSummary = (
    queryFn: (queryParams: { organizationId: number }) => Promise<ServiceResponse<OrganizationEventSummaryRecord>>,
    organizationId: number
) =>
    useQuery({
        queryKey: [QUERY_KEYS.ORGANIZATION_EVENT_SUMMARY, organizationId],
        queryFn: () => queryFn({ organizationId: organizationId }),
        select: (data: ServiceResponse<OrganizationEventSummaryRecord>) => data.resultObjects,
        enabled: !!organizationId,
    });
    
export const useGetOrganizationEventList = (
    queryFn: (queryParams: { organizationId: number, year: number }) => Promise<ServiceResponse<OrganizationEventRecord>>,
    organizationId: number,
    year: number
) =>
    useQuery({
        queryKey: [QUERY_KEYS.ORGANIZATION_EVENT_LIST, organizationId, year],
        queryFn: () => queryFn({ organizationId: organizationId, year: year }),
        select: (data: ServiceResponse<OrganizationEventRecord>) => data.resultObjects,
        enabled: !!organizationId,
    });
    